import { render, staticRenderFns } from "./out-dialog.vue?vue&type=template&id=20b6e77b&scoped=true&"
import script from "./out-dialog.vue?vue&type=script&lang=js&"
export * from "./out-dialog.vue?vue&type=script&lang=js&"
import style0 from "./out-dialog.vue?vue&type=style&index=0&id=20b6e77b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b6e77b",
  null
  
)

export default component.exports